import script from "./PropertyItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyItem.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyItem.vue?vue&type=style&index=0&id=7846c22a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7846c22a"]])

export default __exports__